export class DateHelper {
  convertToSydneyTime(date: Date) {
    return new Date(date.toLocaleString("en-US", {timeZone: "Australia/Sydney"}));
  }
}
